

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import StopsSelectList from "../components/stops-components/StopsSelectList.jsx";
import Status from "../components/Status.jsx";
import StopContainer from "../components/stops-components/StopContainer.jsx";
import useStopsList from "../hooks/useStopsList.js";

/**
 * App - Main application component using centralized RouteDataContext
 */
export default function AllStops() {
  const stopsList = useStopsList();
  const [selectedStop, setSelectedStop] = useState(null);
  const params = useParams();

  useEffect(() => {
    const currentStop = stopsList.find(
      stop => String(stop.stop_id) === String(params.stopId)
    );
    setSelectedStop(currentStop || null);
  }, [stopsList, params.stopId]);


  return (
    <Row className="ictapp__all_stops">
      <Col md={6} className="mb-5">
        <p><strong>Select a Stop</strong></p>
        <StopsSelectList
          stopsList={stopsList}
          selectedStop={selectedStop}
          setSelectedStop={setSelectedStop}
          currentStopId={params.stopId}
        />
      </Col>
      <Status />
      <Col xs={12} className="mb-3">
        {params.stopId ? (
          <StopContainer stopId={params.stopId} />
        ) : null}
      </Col>
         </Row>
  );
}


